import { gql } from '@apollo/client';

export const CREATE_BRAND_NOTE = gql`
  mutation CreateBrandNote($brandId: String!, $message: String!) {
    createInternalNote(brandId: $brandId, message: $message) {
      status
      code
      data
      error
    }
  }
`;

export const CREATE_BRAND_EVENT = gql`
  mutation CreateBrandEvent(
    $brandId: String!
    $name: String!
    $scheduledAt: String
    $type: String!
    $notes: String
  ) {
    createBrandEvent(
      brandId: $brandId
      name: $name
      scheduledAt: $scheduledAt
      type: $type
      notes: $notes
    ) {
      status
      code
      data
      error
    }
  }
`;

export const UPDATE_BRAND_EVENT = gql`
  mutation UpdateBrandEvent(
    $eventId: String!
    $name: String
    $scheduledAt: String
    $type: String
    $notes: String
  ) {
    updateBrandEvent(
      eventId: $eventId
      name: $name
      scheduledAt: $scheduledAt
      type: $type
      notes: $notes
    ) {
      status
      code
      data
      error
    }
  }
`;

export const DELETE_BRAND_EVENT = gql`
  mutation DeleteBrandEvent($eventId: String!) {
    deleteBrandEvent(eventId: $eventId) {
      status
      code
      data
      error
    }
  }
`;

export const UPDATE_BRAND_NOTE = gql`
  mutation UpdateBrandNote($noteId: String!, $message: String!) {
    updateBrandNote(noteId: $noteId, message: $message) {
      status
      code
      data
      error
    }
  }
`;

export const DELETE_BRAND_NOTE = gql`
  mutation DeleteBrandNote($noteId: String!) {
    deleteBrandNote(noteId: $noteId) {
      status
      code
      data
      error
    }
  }
`;

export const UPDATE_BRAND_ACCOUNT_MANAGER = gql`
  mutation UpdateBrandAccountManager($brandId: String!, $userId: String!) {
    updateBrandAccountManager(brandId: $brandId, userId: $userId) {
      status
      code
      data
      error
    }
  }
`;

export const DELETE_BRAND_ACCOUNT_MANAGER = gql`
  mutation DeleteBrandAccountManager($brandId: String!) {
    deleteBrandAccountManager(brandId: $brandId) {
      status
      code
      data
      error
    }
  }
`;
